import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchPlaylists } from "@/lib/queries";

export const Route = createFileRoute("/stemninger")({
  head: () => ({
    meta: [
      { title: "Stemninger – jazz-playlister · Flâneriet" },
      { name: "description", content: "Kuraterede jazz-playlister til aftenlyset – sæt en på, hæld et glas, sid ned." },
      { property: "og:title", content: "Stemninger – jazz-playlister · Flâneriet" },
      { property: "og:description", content: "Kuraterede jazz-playlister til aftenlyset – sæt en på, hæld et glas, sid ned." },
      { property: "og:url", content: "https://flaneriet.online/stemninger" },
    ],
    links: [{ rel: "canonical", href: "https://flaneriet.online/stemninger" }],
  }),
  component: Playlists,
});


function Playlists() {
  const { data } = useQuery({ queryKey: ["playlists"], queryFn: fetchPlaylists });
  return (
    <div className="mx-auto max-w-4xl">
      <header className="border-b border-rule py-14 text-center">
        <p className="eyebrow">Musik · Stemninger</p>
        <h1 className="mt-3 font-serif text-5xl md:text-6xl">Til aftenlyset</h1>
        <p className="mt-4 meta italic max-w-xl mx-auto">
          Kuraterede jazz-playlister – sæt en på, hæld et glas, sid ned.
        </p>
      </header>

      {(data?.length ?? 0) === 0 && (
        <p className="meta italic py-24 text-center">Endnu ingen playlister. Tilføj den første under Redaktion.</p>
      )}

      <div className="py-10 grid gap-14">
        {data?.map((p) => (
          <section key={p.id} className="border-b border-rule pb-10">
            <p className="eyebrow">{p.mood ?? "Jazz"}</p>
            <h2 className="mt-1 font-serif text-3xl">{p.title}</h2>
            {p.description && <p className="mt-2 meta italic max-w-xl">{p.description}</p>}
            <div className="mt-6 border border-rule">
              <iframe
                src={p.spotify_embed_url}
                width="100%"
                height="352"
                frameBorder={0}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title={p.title}
              />
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
